export const ISSUER_TYPE_FILTER = {
  ALL: 'all',
  CUSTOM: 'custom',
  STANDARD: 'standard',
};

/**
 * Expiration statuses as the API reports them.
 *
 * The values are derived server-side by
 * radar-api/src/utils/certificationExpirationStatus.js (ADR-0003 §D9) against a
 * configurable window. Never re-derive a status from the dates in the browser:
 * a clock or timezone a few hours from the server's would flip rows on the
 * window boundary and the screen would disagree with an export taken from it.
 */
export const EXPIRATION_STATUS = {
  EXPIRED: 'expired',
  EXPIRING_SOON: 'expiring_soon',
  VALID: 'valid',
  NO_EXPIRATION: 'no_expiration',
};

const EXPIRATION_STATUS_LABELS = {
  [EXPIRATION_STATUS.EXPIRED]: 'Expired',
  [EXPIRATION_STATUS.EXPIRING_SOON]: 'Expiring Soon',
  [EXPIRATION_STATUS.VALID]: 'Valid',
  [EXPIRATION_STATUS.NO_EXPIRATION]: 'No Expiration',
};

/** Options for the report's Expiration filter, in escalating-urgency order. */
export const EXPIRATION_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: EXPIRATION_STATUS.EXPIRED, label: EXPIRATION_STATUS_LABELS[EXPIRATION_STATUS.EXPIRED] },
  { value: EXPIRATION_STATUS.EXPIRING_SOON, label: EXPIRATION_STATUS_LABELS[EXPIRATION_STATUS.EXPIRING_SOON] },
  { value: EXPIRATION_STATUS.VALID, label: EXPIRATION_STATUS_LABELS[EXPIRATION_STATUS.VALID] },
  { value: EXPIRATION_STATUS.NO_EXPIRATION, label: EXPIRATION_STATUS_LABELS[EXPIRATION_STATUS.NO_EXPIRATION] },
];

/**
 * Human-readable label for an expiration status.
 *
 * Shared by the report badges and the CSV export so the file and the screen use
 * the same words. Unknown values pass through unchanged rather than becoming
 * blank, so a future backend status is visible rather than silently missing.
 *
 * @param {string} status - An EXPIRATION_STATUS value
 * @returns {string}
 */
export const getExpirationLabel = (status) => {
  if (!status) {
    return '';
  }

  return EXPIRATION_STATUS_LABELS[status] ?? status;
};
